import {
    ChangeDetectionStrategy,
    Component,
    computed,
    InputSignal,
    Signal,
    input
} from "@angular/core";
import {Option} from "./option";

@Component({
    selector: "woa-option",
    template: "",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OptionComponent<T> {
    public readonly value: InputSignal<T> = input.required<T>();

    public readonly label: InputSignal<string> = input<string>();

    public option: Signal<Option<T>> = computed<Option<T>>(() => new Option(this.label(), this.value()));
}
